// [MAIN]
import {TopMenuTracker} from "./top-menu/index.js"; // 메인 탑 nav
import {LeftMenuTracker} from "./left-menu/index.js"; // 메인 left 메뉴
// [MINI]
import {MiniLeftMenuTracker} from "./mini-left-menu/index.js"; // 미니 left 메뉴
// [SIGNIN]
import {SignInTracker} from "./signin/index.js"; // 일반 로그인 화면
import {CorpSignTracker} from "./corp-signin/index.js"; // 기업 로그인 화면
// [SIGNUP]
import {SignUpTracker} from "./signup/index.js"; // 일반 회원가입 화면
// [VIEWER]
import {ViewerTracker} from "./viewer/index.js"; // 뷰 체인저 트래커
// [FEATURES]
import {AlarmTabTracker} from "./alarm-filter/index.js"; // 알림 탭
import {MentionTracker} from "./chat-mention/index.js"; // 채팅멘션
import {ProjectInviteTracker} from "./project-invite/index.js"; // 프로젝트 초대
import {ScheduleFilterTracker} from "./schedule/scheduleFilter.js"; // 캘린더
import {TranslateTracker} from "./translate/index.js"; // 번역
import {MiniNoticeTracker} from "./mini-notice/index.js"; // 미니 공지
import {ShortcutTracker} from "./shortcut/index.js"; // 바로가기
import {InviteEmplUserTracker} from "./invite-employee/index.js"; // 직원 초대
import {IntegrationSettingTracker} from "./integration-setting/index.js"; // 직원 초대

const UserTracker = {
    AlarmTabTracker,
    TopMenuTracker,
    LeftMenuTracker,
    MentionTracker,
    MiniLeftMenuTracker,
    ProjectInviteTracker,
    ScheduleFilterTracker,
    SignInTracker,
    CorpSignTracker,
    ViewerTracker,
    TranslateTracker,
    MiniNoticeTracker,
    SignUpTracker,
    ShortcutTracker,
    InviteEmplUserTracker,
    IntegrationSettingTracker,
}

export default UserTracker;
